import PropTypes from 'prop-types'
import { map } from 'lodash'
import { filterPostsByTopicSlug } from '../../lib'
import TopicSection from '../topic-section'

const NUM_VISIBLE_POSTS = 4

const ParentingView = ({ posts, subTopics }) => (
  <>
    {map(subTopics, (topic) => {
      const filteredPosts = filterPostsByTopicSlug(posts, topic.slug)
      return (
        <TopicSection
          key={`topic_section_${topic.slug}`}
          posts={filteredPosts.slice(0, NUM_VISIBLE_POSTS)}
          showAllButton={filteredPosts.length > NUM_VISIBLE_POSTS}
          showTopics={false}
          topic={{ name: topic.name, slug: topic.slug }}
        />
      )
    })}
  </>
)

ParentingView.propTypes = {
  posts: PropTypes.array,
  subTopics: PropTypes.array,
}

export default ParentingView
